import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Communicator } from './tools/Communication';
import { Alert } from 'reactstrap';

const ZohoRedirect = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const zohoId = searchParams.get('zohoId');
  const entityType = location.pathname === '/event' ? 'Event' : 'EventAccount';
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!zohoId) return;

    Communicator.Get('ZohoRedirect/Redirect', {
      zohoId,
      entityType,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.redirectUrl === 'not-found') {
          setError(
            entityType === 'Event'
              ? 'Event not found. This could be because the event has not reached the "Signed Contract" stage in Zoho yet. Events are only synced after reaching this stage.'
              : 'Event Account not found in the system.',
          );
        } else if (data.redirectUrl) {
          window.location.href = data.redirectUrl;
        }
      })
      .catch((err) => {
        console.error(err);
        setError('An error occurred while redirecting.');
      });
  }, [zohoId, entityType]);

  if (error) {
    return (
      <div className="p-4">
        <Alert color="danger">{error}</Alert>
      </div>
    );
  }

  return null;
};

export default ZohoRedirect;
